export default __webpack_public_path__ + "static/media/modal_frame_header_text_large.7f19616f.png";